import { render, staticRenderFns } from "./gc-popup-work-order-release-info.vue?vue&type=template&id=5f97168f"
import script from "./gc-popup-work-order-release-info.vue?vue&type=script&lang=js"
export * from "./gc-popup-work-order-release-info.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-work-order-release-info.vue?vue&type=style&index=0&id=5f97168f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports